import * as React from 'react';
import { ChangeEvent } from 'react';
import { useTranslation } from 'next-i18next';

import { TabComponentType, cn } from '@restworld/utils-common';

import { Checkbox } from '@restworld/ui-components';

export const TermsAndConditions = ({
  isChecked,
  type = 'default',
  iserror,
  onCheckboxChange,
  testId,
  ...rest
}: {
  onCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  isChecked?: boolean;
  type?: TabComponentType;
  iserror?: boolean;
  testId?: string;
}) => {
  const { t } = useTranslation();
  return (
    <Checkbox
      id={`terms-and-conditions-${type}`}
      variant="box"
      iserror={iserror}
      title={
        <TitleWrapper iserror={iserror}>
          <span>{t('common:terms_and_conditions.i_have_read_and_accepted_the')} </span>
          <CustomLink
            href="https://www.restworld.it/termini-worker"
            target="_blank"
            rel="noopener noreferrer"
            iserror={iserror}
          >
            {t('common:terms_and_conditions.terms_and_conditions_of_the_service')}
          </CustomLink>
          <span> e la </span>
          <CustomLink
            href="https://www.restworld.it/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            iserror={iserror}
          >
            privacy policy
          </CustomLink>
        </TitleWrapper>
      }
      isChecked={isChecked}
      mode="clickable"
      onChange={onCheckboxChange}
      testId={testId}
      {...rest}
    />
  );
};
const TitleWrapper = ({ iserror, className, ...props }: any) => (
  <p
    className={cn(
      'text-gray-500 font-light leading-6 text-sm w-full inline-block',
      iserror ? 'text-red-500' : '',
      className
    )}
    {...props}
  />
);
const CustomLink = ({ iserror, className, ...props }: any) => (
  <a className={cn(!iserror ? 'underline underline-offset-4' : '', className)} {...props} />
);
